export default __webpack_public_path__ + "static/media/3.bda0296e.png";